import { render, staticRenderFns } from "./ArealBookingDetails.vue?vue&type=template&id=a0447da4"
import script from "./ArealBookingDetails.vue?vue&type=script&lang=js"
export * from "./ArealBookingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports